import { FieldValues, useController } from 'react-hook-form';
import { DatePicker } from '@spark-web/date-picker';
import { Field } from '@spark-web/field';
import type { DatePickerFieldProps } from './types';

function DatePickerField<TFieldValues extends FieldValues = FieldValues>({
  name,
  label,
  control,
  shouldUnregister,
  FieldProps,
  ...datePickerProps
}: DatePickerFieldProps<TFieldValues>) {
  const {
    field: { onChange, ...field },
    fieldState: { error },
  } = useController<TFieldValues>({
    name,
    control,
    rules: {
      onBlur: datePickerProps.onBlur,
    },
    shouldUnregister,
  });

  const handleChange = (day?: Date) => {
    onChange(day ?? null);

    datePickerProps.onChange?.(day ?? undefined);
  };

  return (
    <Field
      label={label}
      {...FieldProps}
      tone={error ? 'critical' : FieldProps?.tone}
      message={error?.message ?? FieldProps?.message}
    >
      <DatePicker {...datePickerProps} {...field} onChange={handleChange} />
    </Field>
  );
}

export default DatePickerField;
